import { render, staticRenderFns } from "./RoleAccessListing.vue?vue&type=template&id=3da25736"
import script from "./RoleAccessListing.vue?vue&type=script&lang=js"
export * from "./RoleAccessListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports